import { lazy, Suspense } from "react";
import { Loading } from "../../elements/Loading";

// Lazy so the statistics aren't loaded behind every record page.
const Statistics = lazy(() => import("./AbTestStatistics"));

export function LazyAbTestStatistics() {
  return (
    <Suspense fallback={<Loading />}>
      <Statistics />
    </Suspense>
  );
}
